import Translation from 'lib/helpers/translation';

export const resultsTranslations = {
  ...Translation.group('results'),
  transportationTypes: {...Translation.group('transportationTypes')},
  paymentMethods: {...Translation.group('paymentMethods')},
  insuranceFlexible: {...Translation.group('insuranceFlexible')},
  time: {...Translation.group('time')},
  seats: {...Translation.group('seats')},
  stops: {...Translation.group('stopsCount')},
  metaResults: {...Translation.group('metaResults')},
  baggageFreeInfo:{...Translation.group('baggageFreeInfo')}
};
